export default __webpack_public_path__ + "static/media/prize.min.ae3c1949.png";